import { formatMoney } from "../../../../utils/formatters";
import { formatAvailableLabel, hasValue } from "../../helpers/decisionNarrativeHelpers";
import { Metric, SectionHeading } from "./NarrativePresentation";

const unavailable = "Not available";

const formatCount = (value) => hasValue(value) ? String(value) : unavailable;
const formatCurrentMoney = (value, currency) => hasValue(value) ? formatMoney(value, currency) : unavailable;

export const CurrentBaseline = ({ currency, scenarioCount, currentBaseline }) => (
  <section aria-labelledby="current-baseline-title" className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
    <SectionHeading eyebrow="Where are we today?" title="Current Baseline" id="current-baseline-title" description="The organization’s current quantified portfolio position before any new investment authorization." />
    <div className="mt-6 grid gap-4 sm:grid-cols-2 xl:grid-cols-5">
      <Metric label="Current Expected Annual Loss" value={formatCurrentMoney(currentBaseline?.expectedAnnualLoss, currency)} detail="Current modeled position" />
      <Metric label="Current Capital at Risk P95" value={formatCurrentMoney(currentBaseline?.capitalAtRiskP95, currency)} detail="Current modeled position" />
      <Metric label="Active Scenarios" value={formatCount(scenarioCount)} detail="Portfolio decision scope" />
      <Metric label="Scenarios with Protection Gaps" value={formatCount(currentBaseline?.scenariosWithProtectionGaps)} detail="Active scenarios with marginal, underinsured, or no coverage" />
      <Metric label="Current Portfolio Risk-Appetite Alignment" value={formatAvailableLabel(currentBaseline?.riskAppetitePosition)} detail="EAL, P95, and top-scenario concentration vs approved thresholds" />
    </div>
  </section>
);
